<template lang="html">
  <div>
    <players-in-game></players-in-game>
    <modal :show="show_player" large="true" effect="fade" backdrop="false">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Tarjeta de jugador</h4>
        <span v-show="show_spinner">
          <scale-loader></scale-loader>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        <player :player="player"></player>
        <card-editor :show_player_cards="show_player_cards"></card-editor>
        <card :show_card="show_card"></card>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click='closeModal'>Cerrar</button>
      </div>
    </modal>
  </div>
</template>

<script>
import PlayersInGame from '../components/PlayersInGame'
import Card from '../components/Card.vue'
import CardEditor from '../components/CardEditor.vue'
import {modal} from 'vue-strap'
import Player from '../components/Player'
import {
  getCurrentChampionship,
  getCurrentDate,
  getCurrentPlayer,
  getCardSaved,
  getPlayersReady,
  getPlayersWaiting,
  getShowPlayer,
  getShowCard,
  getShowPlayerCards,
  getLoading
} from '../vuex/getters'
import * as actions from '../vuex/actions'

export default {
  vuex: {
    getters: {
      championship: getCurrentChampionship,
      date: getCurrentDate,
      player: getCurrentPlayer,
      card_saved: getCardSaved,
      players_ready: getPlayersReady,
      players_waiting: getPlayersWaiting,
      show_player: getShowPlayer,
      show_card: getShowCard,
      show_player_cards: getShowPlayerCards,
      show_spinner: getLoading
    },
    actions: actions
  },
  data() {
    return {
    };
  },
  methods: {
    closeModal() {
      this.showPlayerCards(false);
      this.showPlayer(false);
      this.showCard(false);
      this.initHoles();
    }
  },
  components: { PlayersInGame, Card, CardEditor, modal, Player }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Players.vue?728275a6
 **/